import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';

const initialState = { 
    feesDefaulterListing: null,
    feesDefaulterCount: '...',
    metaData: null,
    currentPage: 1,
    mounted: false,
    classId: '0',
    residenceId: '0',
    searchText: '',
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const FeesDefaulterContext = createContext();

export const FeesDefaulterProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getFeesDefaulterListing();
      }
    }, [state.currentPage])

  const getFeesDefaulterListing = async (refresh = false) => {

    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "feesDefaulterListing", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
      }

    const payloadData = {
        'page':refresh ? 1: state.currentPage,
        'student_class': state.classId,
        'student_residence': state.residenceId,
        
      };


    const server_response  = await ajaxSchool.fetchFeesDefaulters(payloadData);
      if(server_response.status === "OK"){
        
            const newTransactions = server_response.details.data;
            dispatch({
            type: "feesDefaulterListing",
            payload: refresh
                ? newTransactions
                : state.feesDefaulterListing
                ? [...state.feesDefaulterListing, ...newTransactions]
                : newTransactions
            });

          dispatch({ type: "metaData", payload: server_response.details.meta });

      }else{
        dispatch({ type: 'feesDefaulterListing', payload: '404' });
        dispatch({ type: "meta", payload: "404" });

      }
  };

  const getFeesDefaulterCount = async () => {
    const server_response  = await ajaxSchool.fetchFeesDefauterCount();
    if(server_response.status === "OK"){
        dispatch({ type: 'FeesDefaulterCount', payload: server_response.details });
    }else{
        dispatch({ type: 'FeesDefaulterCount', payload: '404' });
    }
  };

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const filter = async()=>{
    await getFeesDefaulterListing(true);
  }


  return(
    <FeesDefaulterContext.Provider value={{
      ...state, 
      dispatch, 
      getFeesDefaulterListing,
      getFeesDefaulterCount,
      setCurrentPage,
      filter
      }}>
      {children}
    </FeesDefaulterContext.Provider>
  )

}

export const useFeesDefaulter = ()=>useContext(FeesDefaulterContext);

